import { Component } from '@angular/core';

@Component({
	selector: 'app-ai-assistant-button',
	templateUrl: './ai-assistant-button.component.html',
	styleUrls: ['./ai-assistant-button.component.css'],
})
export class AiAssistantButtonComponent {
	openAssistant() {
		window.open('/#/ai-chat', '_blank');
	}
}
